const MainColor = {
	primary: "#2df",
	success: "#2f9",
	danger: "#f18",
	info: "#ce0",
	warning: "#fa3",
	white: "#fff",
	grey1: "#efefef",
	grey2: "#464599",
	inactive: "#413D3D",
	yellow1: "#DD9546",
	yellow2: "rgba(221, 149, 70, 0.1)",
	darkBlue: "#051922",
	blue1: "rgba(31, 30, 125, 0.8)",
	green1: "#0B9794",
}

export const colors = {
	primary: MainColor.primary,
	success: MainColor.success,
	danger: MainColor.danger,
	info: MainColor.info,
	warning: MainColor.warning,
	inactive: MainColor.inactive,
	defaultImage: MainColor.green1,
	text: {
		primary: MainColor.white,
		secondary: MainColor.grey1,
	},
	card: {
		background: MainColor.darkBlue,
		textPrimary: MainColor.white,
		textSecondary: MainColor.success,
	},
	empty: {
		background:MainColor.yellow2,
		border: MainColor.yellow1,
	},
	container: {
		background: MainColor.blue1,
		border: MainColor.white,
	}
}